import { useEffect, useState, useMemo, useCallback } from "react";
import WebSocketManager from "../../../../ws/client";

export function useStudentLiveUpdate(initialClient) {
  const [liveClient, setLiveClient] = useState(initialClient);

  useEffect(() => {
    setLiveClient(initialClient);
  }, [initialClient]);

  const studentId = useMemo(() => {
    return initialClient?.id_student;
  }, [initialClient]);

  const topic = useMemo(() => {
    if (!studentId) return null;
    return `/topic/student-${studentId}`;
  }, [studentId]);

  const handleMessage = useCallback((event) => {

    try {

      const { type, payload } = event;

      if (type === "UPDATED" && payload) {
        setLiveClient(payload);
      }

    } catch (err) {

      console.error("Erro ao processar update live:", err);

    }

  }, []);

  useEffect(() => {

    if (!topic) return;

    WebSocketManager.subscribe(topic, handleMessage);

    return () => {
      WebSocketManager.unsubscribe(topic);
    };

  }, [topic, handleMessage]);

  return liveClient;
}